import React from 'react';
import { Backdrop, CircularProgress, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 9999,
    color: theme.palette.primary.main
  }
}));

interface Props {
  open: boolean;
  invisible?: boolean;
}

const LoadingPresenter: React.FC<Props> = ({ open, invisible = false }) => {
  const { backdrop } = useStyles();
  return (
    <Backdrop className={backdrop} open={open} invisible={invisible}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default LoadingPresenter;
